// extracted by mini-css-extract-plugin
var _1 = "mKu9B";
export { _1 as "mecontrolPlaceHolderStyle" }
